import { Screen } from "../pages/StartScreen/StartScreen";

const screenRouteMap = new Map<Screen, string>()
    .set("START", "/")
    .set("ACCOUNT", "/account")
    .set("ACCOUNT_OVERVIEW", "/account-overview")
    .set("ENTER_PIN", "/enter-pin")
    .set("CHANGE_PIN", "/change-pin")
    .set("CASHOUT", "/cash-out")
    .set("LIMITS_AND_CLOSURE", "/limits-and-closure")
    .set("RETHINK_IDLE", "/rethink-idle");

const screenToRoute = (screen: Screen | undefined) => {
    if (!screen) {
        return screenRouteMap.get("START") as string;
    } else if (screenRouteMap.has(screen)) {
        return screenRouteMap.get(screen) as string;
    } else {
        return screenRouteMap.get("RETHINK_IDLE") as string;
    }
};

export default screenToRoute;
